import { ref, computed, watch } from 'vue'
import dayjs from 'dayjs'
import { format } from '@/lib/helpers/time'

export default () => {
    const defaultPeriod = 'month'
    const periodLocal = ref(defaultPeriod)
    const period = computed({
        get() {
            return periodLocal.value
        },
        set(newValue) {
            if (['day', 'month', 'week', 'year'].includes(newValue)) {
                periodLocal.value = newValue
            } else {
                periodLocal.value = defaultPeriod
            }
        },
    })
    const today = ref(new Date())
    const defaultDateSelected = computed(() => dayjs(today.value).startOf(period.value))
    const dateSelectedLocal = ref(defaultDateSelected.value)
    const dateSelected = computed({
        get() {
            return dateSelectedLocal.value.toDate()
        },
        set(newValue) {
            if (dayjs(newValue).isValid()) {
                dateSelectedLocal.value = dayjs(newValue).startOf(period.value)
            } else {
                dateSelectedLocal.value = defaultDateSelected.value
            }
        },
    })

    const numberOfDays = computed(() => {
        switch (period.value) {
            case 'day':
                return 1
            case 'month':
                return 42
            case 'week':
                return 7
            case 'year':
                return 365
        }
    })

    const getFirstDay = (date) => date.startOf('week').toDate()
    const getLastDay = (date, days) => date.startOf('week').add(days, 'day').toDate()

    const firstCalendarDay = computed(() => getFirstDay(dateSelectedLocal.value))
    const lastCalendarDay = computed(() => getLastDay(dateSelectedLocal.value, numberOfDays.value))
    const calendarDateFrom = computed(() => format(firstCalendarDay.value, 'YYYY-MM-DD'))
    const calendarDateTo = computed(() => format(lastCalendarDay.value, 'YYYY-MM-DD'))

    /**
     * Methods
     */

    const gotoToday = () => {
        today.value = new Date() // update today ref
        dateSelectedLocal.value = defaultDateSelected.value // force update the current date selected
    }

    const getNextPeriodDate = (date, p) => date.add(1, p)
    const getPreviousPeriodDate = (date, p) => date.subtract(1, p)

    const incrementPeriod = () => {
        dateSelectedLocal.value = getNextPeriodDate(dateSelectedLocal.value, period.value)
    }

    const decrementPeriod = () => {
        dateSelectedLocal.value = getPreviousPeriodDate(dateSelectedLocal.value, period.value)
    }

    const getPreviousCalendarRange = () => {
        const prevDate = getPreviousPeriodDate(dateSelectedLocal.value, period.value)
        return [getFirstDay(prevDate), getLastDay(prevDate, numberOfDays.value)]
    }

    return {
        // properties
        period,
        numberOfDays,
        dateSelected,
        firstCalendarDay,
        lastCalendarDay,
        calendarDateFrom,
        calendarDateTo,
        // methods
        gotoToday,
        incrementPeriod,
        decrementPeriod,
        getPreviousCalendarRange,
    }
}
